import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { formatMessage } from '../../../lib/intl';

const i18n = defineMessages({
  progress: {
    id: 'contributorsProgress.progress.commitedOfMinimum',
    defaultMessage: '{committedSlots} of a minimum of {minSlots}',
  },
  fewSlotsLeft: {
    id: 'contributorsProgress.progress.fewSlotsLeft',
    defaultMessage: `{slotsLeft, plural,
      one {Minimum met 😀 Only {slotsLeft} slot}
      other {Minimum met 😀 Only {slotsLeft} slots} } left.`
  },
  minMet: {
    id: 'contributorsProgress.progress.minimumMet',
    defaultMessage: 'Minimum met 😀 Join soon!',
  },
  groupFull: {
    id: 'contributorsProgress.progress.groupFull',
    defaultMessage: '{committedSlots} of {maxSlots} allowed. Group is full.',
  },

  contributors: {
    id: 'contributorsProgress.title',
    defaultMessage: '{SlotsName}',
  },
  contributors_adult: {
    id: 'contributorsProgress.title_adult',
    defaultMessage: 'Adults',
  },
  contributors_passenger: {
    id: 'contributorsProgress.title_passenger',
    defaultMessage: 'Passengers',
  },
  contributors_ticket: {
    id: 'contributorsProgress.title_ticket',
    defaultMessage: 'Tickets',
  },
  contributors_seat: {
    id: 'contributorsProgress.title_seat',
    defaultMessage: 'Seats',
  },
  contributors_item: {
    id: 'contributorsProgress.title_item',
    defaultMessage: 'Items',
  },
  contributors_shirt: {
    id: 'contributorsProgress.title_shirt',
    defaultMessage: 'Shirts',
  },
  contributors_person: {
    id: 'contributorsProgress.title_person',
    defaultMessage: 'People',
  },
  contributors_guest: {
    id: 'contributorsProgress.title_guest',
    defaultMessage: 'Guests',
  },
  contributors_player: {
    id: 'contributorsProgress.title_player',
    defaultMessage: 'Players',
  },
  contributors_student: {
    id: 'contributorsProgress.title_student',
    defaultMessage: 'Students',
  },
});

class ContributorsProgress extends Component {
  constructor(props) {
    super(props);
    this.formatMessage = formatMessage(this.props.intl);
  }

  renderDisplayText() {
    const { minSlots, maxSlots, committedSlots, isCompleted } = this.props;

    if (isCompleted) {
      return committedSlots;
    }

    if (minSlots > 1 && committedSlots < minSlots) {
      return this.formatMessage(i18n.progress, { committedSlots, minSlots });
    }

    if (maxSlots && committedSlots === maxSlots) {
      return this.formatMessage(i18n.groupFull, { maxSlots, committedSlots });
    }


    if (minSlots > 1 && committedSlots >= minSlots && maxSlots && maxSlots > minSlots) {
      const slotsLeft = maxSlots - committedSlots;

      return this.formatMessage(i18n.fewSlotsLeft, { slotsLeft });

    }

    if (minSlots > 1 && committedSlots >= minSlots && !maxSlots) {
      return this.formatMessage(i18n.minMet);
    }

    if (minSlots <= 1) return this.formatMessage(i18n.minMet);

    return;
  }

  render() {
    const { purchase } = this.props;

    return (
      <div className="row align-items-center mb-4">
        <div className="col-3 text-center">
          <i className="fa fa-group round-border medium cool-grey" />
        </div>
        <div className="col-9">
          <h4 className="mb-0">
            {this.formatMessage(i18n.contributors, purchase.slotName)}
          </h4>
          <span className="contribution-muted-text">
            {this.renderDisplayText()}
          </span>
        </div>
      </div>
    );
  }
}

ContributorsProgress.defaultProps = {
  purchase: { slotName: null }
}

export default injectIntl(ContributorsProgress);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/contributors-progress.js